import {
	type LoaderFunctionArgs,
	type MetaFunction,
	useLoaderData,
} from 'react-router'
import { SiteShell } from '#app/components/site/SiteShell'
import { LegalPage } from '#app/components/site/legal'
import { TERMS_OF_SERVICE } from '#app/data/legal/terms'
import { getAudience } from '#app/utils/site/audience.server'
import { siteContent } from '#app/utils/site/content'
import { siteLinks } from '#app/utils/site/site-links'
import { siteMeta } from '#app/utils/site/site-meta'

export const handle = { chrome: 'site' } as const
export const links = siteLinks()
export const meta: MetaFunction = () => siteMeta(siteContent.meta.terms)

export async function loader({ request }: LoaderFunctionArgs) {
	return { audience: await getAudience(request) }
}

export default function TermsOfServiceRoute() {
	const { audience } = useLoaderData<typeof loader>()
	return (
		<SiteShell audience={audience}>
			<LegalPage doc={TERMS_OF_SERVICE} />
		</SiteShell>
	)
}
